import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  mobileForm: FormGroup = this.fb.group({
    mobileCode: ['5bde1eaa-2cd1-4a46-ad1f-a1b21020bdae', Validators.required],
    mobileNumber: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(9)]]
  });

  emailForm: FormGroup = this.fb.group({
    emailId: ['', [Validators.required, Validators.email]]
  });

  isSubmittedMobile: boolean = false;
  isSubmittedEmail: boolean = false;
  isSubmittedPolicy: boolean = false;
  countryCodes: any = [];

  OTPForm: FormGroup = this.fb.group({
    otp: [null, Validators.required],
  });

  emaiauthentication: any;
  showResend: boolean = false;
  timeRemaining_percent!: number;
  otp: string = '';
  intervalId: any;
  resendCountdown: number = 60;
  timer!: number;
  remainingTime!: any;
  oTPID: any;
  loginBoolean: boolean = true;
  submitted: boolean = false;
  @ViewChild('otpInput') otpInput!: ElementRef;
  submittedotp: boolean = false;
  mfaAuthenticationTypeID: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loader: LoaderService,
    private restService: RestService,
    private renderer: Renderer2,
    private authService: AuthService,
    private errorHandler: ErrorHandlerService,
  ) { }

  ngOnInit(): void {
    for (let i = 0; i < 6; i++) {
      this.OTPForm.addControl(
        'otp' + i,
        new FormControl('', Validators.required)
      );
    }
    this.OTPForm.valueChanges.subscribe((value) => {
      this.submittedotp = false;
    });
    this.FetchAllCountryCode();
  }

  FetchAllCountryCode() {
    this.loader.show();
    this.restService.postDataDs(null, 'api/digital/core/Customer/FetchAllCountryCode').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.countryCodes = data.rObj.fetchMasterData || [];
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }


  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  MobileFormSubmit() {
    this.isSubmittedMobile = true;
    if (this.mobileForm.invalid) {
      return;
    }

    this.Register();
  }

  EmailFormSubmit() {
    this.isSubmittedEmail = true;
    if (this.emailForm.invalid) {
      return;
    }

    this.Register();
  }

  PolicyFormSubmit() {
    this.isSubmittedPolicy = true;
    // this.router.navigate(['quotation/get-quote']);
  }

  ResetFormOnTabClick() {
    this.isSubmittedMobile = false;
    this.isSubmittedEmail = false;
    this.isSubmittedPolicy = false;

    this.mobileForm.reset();
    this.emailForm.reset();
  }


  Register() {
    let params = {
      emailID: this.emailForm.get('emailId')?.value || null,
      phoneNumber: this.mobileForm.get('mobileNumber')?.value || null,
      countryCodeID: this.mobileForm.get('mobileCode')?.value || null
    }
    this.loader.show();
    this.restService.postDataDs(params, 'api/digital/core/Customer/Register').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              let otpToSet = data.rObj?.OTP?.toString();

              // for (let i = 0; i < otpToSet.length; i++) {
              //   this.OTPForm.get('otp' + i)?.setValue(otpToSet[i]);
              // }
              this.oTPID = data.rObj?.authenticationUniqueCode;
              this.mfaAuthenticationTypeID = data.rObj.mfaAuthenticationTypeID
              this.emaiauthentication = data.rObj?.message;
              this.loginBoolean = false;
              this.submitted = false;
              this.startTimer();
              this.loader.hide();
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  resendOtp() {
    let params = {
      emailID: this.emailForm.get('emailId')?.value || null,
      phoneNumber: this.mobileForm.get('mobileNumber')?.value || null,
      countryCodeID: this.mobileForm.get('mobileCode')?.value || null
    }

    this.loader.show();
    this.restService.postUATData(params, 'api/digital/core/Customer/Register').subscribe(
      (data: any) => {
        try {
          if (data.rcode == 200 || data.rcode == 203) {
            let otpToSet = data.rObj?.OTP?.toString();

            // for (let i = 0; i < otpToSet.length; i++) {
            //   this.OTPForm.get('otp' + i)?.setValue(otpToSet[i]);
            // }
            this.oTPID = data.rObj?.authenticationUniqueCode;
            this.emaiauthentication = data.rObj?.message;
            this.loginBoolean = false;
            this.submitted = false;
            this.startTimer();
            this.setFocusOnOTPInput();
            this.showResend = false;
          } else {
            this.errorHandler.handleRcodeError(data);
          }
        } catch (error) {
          this.errorHandler.internalError();
        } finally {
          this.loader.hide();
        }
      },
      (error) => {
        this.loader.hide();
        this.errorHandler.handleStatusError(error);
      }
    );
  }

  getOtp() {
    let otp = '';
    for (let i = 0; i < 6; i++) {
      otp += this.OTPForm.controls['otp' + i].value;
    }
    this.OTPForm.controls['otp'].setValue(otp);
  }

  otpSubmit() {
    this.getOtp();
    this.submittedotp = true;
    if (this.OTPForm.invalid) {
      return;
    }
    let params = {
      authenticationUniqueCode: this.oTPID,
      oTP: this.OTPForm.get('otp')?.value,
      mfaAuthenticationTypeID: this.mfaAuthenticationTypeID
    };
    let url = 'api/digital/core/Customer/ValidateOTP';
    this.loader.show();
    this.restService.postUATData(params, url).subscribe(
      (data: any) => {
        try {
          if (data.rcode == 200) {
            this.authService.b2cAttemptAuth(data.rObj.token);
            const redirectUrl = this.authService.redirectUrl ? this.authService.redirectUrl : '/';
            this.router.navigate([redirectUrl]);
          } else {
            this.errorHandler.handleRcodeError(data);
          }
        } catch (error) {
          this.errorHandler.internalError();
        } finally {
          this.loader.hide();
        }
      },
      (error) => {
        this.loader.hide();
        this.errorHandler.handleStatusError(error);
      }
    );
  }

  get b() {
    return this.OTPForm.controls;
  }

  onInputChange(event: Event, forWhat: string) {
    this.OTPForm.controls[forWhat].setValue(
      (event.target as HTMLInputElement).value.replace(/\D/g, '')
    );
  }
  onBackspaceKeyDown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace') {
      event.preventDefault();
      if (index >= 0) {
        this.OTPForm.controls['otp' + index].setValue(''); // Delete the previous item in the OTP array
        if (index > 0) {
          this.OTPForm.controls['otp' + (index - 1)].setValue('');
        }
        const previousInputId = 'otp' + (index - 1);
        const previousInputElement = document.getElementById(
          previousInputId
        ) as HTMLInputElement;
        if (previousInputElement) {
          previousInputElement.focus(); // Focus the previous input box
        }
      }
    }
  }

  onOtpInput(index: number) {
    const nextIndex = index + 1;
    this.otp = this.otp + this.OTPForm.controls['otp' + index].value;
    if (nextIndex < 6 && this.OTPForm.controls['otp' + index].value) {
      const input = <HTMLInputElement>(
        document.getElementById('otp' + nextIndex)
      );
      input.focus();
    }
  }

  startTimer() {
    this.stopCountdownTimer();
    this.resendCountdown = 60;
    this.timer = this.resendCountdown;
    this.remainingTime = this.timer;
    this.timeRemaining_percent = (this.remainingTime / this.timer) * 100;
    this.intervalId = setInterval(() => {
      this.remainingTime--;
      this.timeRemaining_percent = (this.remainingTime / this.timer) * 100;
      if (this.remainingTime <= 0) {
        this.stopCountdownTimer();
        this.showResend = true;
      }
    }, 1000);
  }

  stopCountdownTimer() {
    clearInterval(this.intervalId);
  }

  setFocusOnOTPInput() {
    setTimeout(() => {
      if (this.otpInput?.nativeElement) {
        this.renderer.selectRootElement(this.otpInput.nativeElement).focus();
      }
    }, 100);
  }

  goBack() {
    this.loader.show();
    this.submittedotp = false;
    for (let i = 0; i < 6; i++) {
      this.OTPForm.controls['otp' + i].setValue('');
    }
    this.loader.hide();
    this.loginBoolean = true;

  }
}


